import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import UploadImage from "common/uploadImage";
import { SHOW_STATUS, UPDATE_STATUS, ADD_STATUS, LANGUAGES_SEARCH, UPLOAD_FILE } from "helpers/api_endpoints";

//meta title
document.title = "Edit Status";

const EditStatus = () => {

    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [status, setStatus] = useState(0);
    const [notify, setNotify] = useState(0);
    const [name, setName] = useState('');
    const [imagePath, setImagePath] = useState(null);
    const [valued, setValued] = useState({"title":[]});
    const [languages, setLanguages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        get(`${SHOW_STATUS}/${params.id}`)
            .then(response => {
                const status = response.data;
                setid(params.id);
                setName(JSON.stringify(status.named));
                if (status.named && status.named.title) {
                    setValued(status.named);
                } else {
                    setValued({ title: [{ 1: status.name }] }); // fallback for default language
                }
                setStatus(status.status);
                setNotify(status.notify);
                setImagePath(status.symbol);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                navigate('/status');
            })
    }, []);

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, []);

    const handleName = (languageId,value) => {
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }

    const handleSubmit = () => {
        console.log()
        // const imagePath = document.getElementById('imagePath').value;
        const config = { id, name, status, notify, symbol: imagePath };
        // if(anew == 1)
        // {
        //     delete config.id;
        //     post(ADD_STATUS, config)
        //     .then(response => {
        //         if (response.code == 200) {
        //             navigate('/status', { state: { successMsg: 'Added SuccessFully' } });
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error.response);
        //     })
        // }
        // else
        {
            put(UPDATE_STATUS, config)
                .then(response => {
                    if (response.code == 200) {
                        navigate('/status', { state: { successMsg: 'Updated SuccessFully' } });
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
        }
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }

    const handleFileUpload = (event) => {
        // setLoading(true);
        const file = event.target.files[0];
        console.log(file.type);
        if(file.size > 1*1024*1024)
        {
            seterrorMsg('File size is larger than 1MB');
            setTimeout(()=>{
                seterrorMsg('');
            },1700)
        }
        if(file.type != 'image/jpeg' && file.type != 'image/png')
        {
            seterrorMsg('File type is incorrect');
            setTimeout(()=>{
                seterrorMsg('');
            },1700)
        }
        post(`${UPLOAD_FILE}`, { file, type:"statuses", fullPath:"true" }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const data = response.data;
                setImagePath(data.path);
                // setLoading(false);
            })
            .catch((error) => {
            });
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Offers" breadcrumbItem="Edit Status" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                            {
                                                languages.map((language, index) => (
                                                    <Row key={index}>
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            value={valued.title?valued.title.find(el => {return el[language.id]})?valued.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(valued)}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required={language.id==1||language.id==2?true:false} ></Input>
                                                    </div>
                                                </Row>
                                                ))
                                            }

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={1}
                                                            id="defaultCheck2"
                                                            checked={status == 1}
                                                            onClick={handleToggleCheckBoxStatus}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="defaultCheck2"
                                                        >
                                                            <Trans>Active</Trans>
                                                        </label>
                                                    </div>
                                                    <div className="form-group col-md-12 mt-2">
                                                        <Label className="form-label"><Trans>Image</Trans></Label>
                                                        <input className="form-control" type="file" onChange={handleFileUpload} />
                                                        <img src={imagePath} style={{ maxHeight: "100px", marginTop: "10px" }} />
                                                    </div>                                                    
                                                </div>

                                                <div className="form-group col-md-2 mt-2">
                                                    <Label className="form-label"><Trans>Notify</Trans></Label>
                                                    <Input
                                                        name="notify"
                                                        value={notify}
                                                        className="form-control"
                                                        placeholder=""
                                                        type="number"
                                                        onChange={(e) => setNotify(e.target.value)}
                                                        required 
                                                        ></Input>
                                                </div>


                                                <div className="mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                    <Button type="submit" onClick={(e) => setNew(1)} color="info">
                                                        <Trans>Submit As New</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditStatus
